export enum EventType {
  ClickPayButton = 'click_pay_button',
}
